export default "__VITE_ASSET__SPmWL1tl__"